'use client';

import { useEffect, useRef } from 'react';
import { useInboxMessageMutations } from '../../hooks/useInboxMessageMutations/useInboxMessageMutations';

type OpenReadControllerProps = {
  id: string;
  readDate: string | undefined;
};

/**
 * Client side component, that tracks the opening and reading of a message.
 * @param id - message id
 * @param readDate - read date
 * @returns null
 */
function OpenReadController({ id, readDate }: OpenReadControllerProps) {
  const { openMessageMutation, markMessageAsReadMutation } = useInboxMessageMutations(id);
  const hasTrackedRef = useRef<string | null>(null);
  const openMutateRef = useRef(openMessageMutation.mutate);
  const readMutateRef = useRef(markMessageAsReadMutation.mutate);

  useEffect(() => {
    openMutateRef.current = openMessageMutation.mutate;
    readMutateRef.current = markMessageAsReadMutation.mutate;
  });

  useEffect(() => {
    if (hasTrackedRef.current === id) return;
    hasTrackedRef.current = id;
    openMutateRef.current(undefined);
    if (!readDate) {
      readMutateRef.current(undefined);
    }
  }, [id, readDate]);

  return null;
}

export { OpenReadController };
